import {Component, OnChanges, OnInit, ViewChild} from '@angular/core';
import {UserDetailComponent} from "../user-detail/user-detail.component";
import {BehaviorSubject, Observable} from "rxjs";
import {UserService} from "../shared/model/user.service";
import {AuthService} from "../shared/security/auth.service";
import {TranslateService} from "@ngx-translate/core";
import {Reservation} from "../shared/model/reservation";
import {ReservationsService} from "../shared/model/reservations.service";
import {CommandService} from "../shared/model/command.service";
import {TenantService} from "../shared/model/tenant.service";

@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.css']
})
export class ReservationsComponent implements OnInit, OnChanges {
  reservations$: Observable<Reservation[]>;
  clubId$: BehaviorSubject<string>;

  clubIdForUser: string;
  tenantIdForUser: number;

  inEditMode: boolean = false;
  inDeleteMode: boolean = false;
  inResetMode: boolean = false;

  selectedRow: number;
  selectedReservation: Reservation;

  dbPath: string = '';
  confirmationTitle: string = '';
  confirmationText: string = '';
  email: string = '';

  showAddReservation: boolean = false;
  showUpdateReservation: boolean = false;

  constructor(private reservationsService: ReservationsService, private authService: AuthService, private translate: TranslateService,
              private commandService: CommandService, private tenantService: TenantService) {
    this.clubIdForUser = this.authService.getClubIdForUser();
    this.tenantIdForUser = this.authService.getTenantIdForUser();
  }

  ngOnChanges() {
    this.reservations$ = null;
  }

  ngOnInit() {
    // TODO: fix authservice authentication
    let clubIdForUser = this.authService.getClubIdForUser();
    this.clubId$ = new BehaviorSubject(clubIdForUser);

    //console.log(`ngOnInit(reservations component): ${clubIdForUser}`);
    this.reservations$ = this.reservationsService.findReservationsForClub(clubIdForUser);
  }

  removeSelectedReservation(row: number, reservation: string) {
    this.selectedRow = row;

    //let reservationId = parseInt(reservation);
    let clubId = this.authService.getClubIdForUser();
    let user = this.authService.getUserName();

    //console.log( `reservationId: ${reservationId}, clubId: ${clubId}, user: ${user}`);

    this.commandService.addCommand(clubId, reservation, "", null, "DB_DELETE_RESERVATION", -1, false, "", user, 'database');
  }

  reservationType( type: string ): string {
    if ( type === 'off' ) {
      return 'l.off';
    } else {
      return 'l.on';
    }
  }

  descriptionText( d: string ): string {
    let r = d;
    if ( (d !== undefined) && (d.trim().length > 8) ) {
      r = '...' + d.slice(d.length - 8);
    }
    return r;
  }

  public showModalReservationWindow( show: boolean ) {
    //console.log(`showModalAgendaWindow is ${show}`);
    this.showAddReservation = show;
  }

  public showModalUpdateReservationWindow( show: boolean ) {
    //console.log(`showModalUpdateAgendaWindow is ${show}`);
    this.showUpdateReservation = show;
  }
}
